// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a2c52e73","732":"b979ba07","977":"b177ee81"}[chunkId] + ".chunk.js";
};